import axios from 'axios';
import Vue from 'vue'

export default {

    getOnlyVisibleSuppliers (filter , page, pageSize,type) {
        return axios.get('/api/suppliers/find/byType', { params: {  filter: filter,page: page, pageSize: pageSize, type:type, onlyVisible:true } })
        .then(suppliersListDTO => {
            if (suppliersListDTO && suppliersListDTO.data) return suppliersListDTO.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getSuppliers (filter , page, pageSize,type) {
        return axios.get('/api/suppliers/find/byType', { params: {  filter: filter,page: page, pageSize: pageSize, type:type } })
        .then(suppliersListDTO => {
            if (suppliersListDTO && suppliersListDTO.data) return suppliersListDTO.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    loadSupplier (selectedSupplier) {
        return axios.get('/api/suppliers/load',  { params: { id: selectedSupplier } } )
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getIsInvoiceSupported() { 
        return axios.get('/api/suppliers/issnvoicesupported')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getIsPreOrderSupported() { 
        return axios.get('/api/suppliers/ispreorder')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    addSupplier(supplierCode) {
        var registerRequest = {username:'', password: '', name: '', supplierCode: supplierCode}
        return axios.post('/api/suppliers/add', registerRequest)
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    getName(){
        return axios.get('/api/suppliers/name')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getAllSuppliersCount(){
        return axios.get('/api/suppliers/count')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getCount(type){
        return axios.get('/api/suppliers/count/byType', { params: { type: type } })
        .then(response => {
            if (response && (response.data|| response.data ===0))   return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getCountLabortoryAndProvide(type){
        return axios.get('/api/suppliers/count/bySuppliersAndProviders', { params: { type: type } })
        .then(response => {
            if (response && (response.data))   return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getAllSuppliers (isPreOrderSupported) {
        return axios.get('/api/suppliers/all', { params: { isPreOrderSupported: isPreOrderSupported } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getAllNewSuppliers () {
        return axios.get('/api/suppliers/all-new')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    exportPDF(fileGeneratedName,fileName){
        axios({
            url:'/api/suppliers/get/'+fileGeneratedName,
            method: 'GET',
            responseType: 'blob', // important
          }).then((response) => {

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
          });
    },

    getProvidersFiles (selectedProvider) {
        return axios.get('/api/suppliers/providersFiles',  { params: { id: selectedProvider } } )
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getAllSuppliersForAdmin (filter , page, pageSize,type) {
        return axios.get('/api/suppliers/admin/list', { params: {  filter: filter,page: page, pageSize: pageSize, type:type } })
        .then(suppliersListDTO => {
            if (suppliersListDTO && suppliersListDTO.data) return suppliersListDTO.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },


    saveSupplier(supplier){
        return axios.post("/api/suppliers/save",supplier)
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success((supplier.supplierType===0 ? "Fournisseur ":"Préstataire ")+"enregistré avec succès");
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    saveProvidersFiles(formData,id){
        return axios.post("/api/suppliers/saveProvidersFiles/"+id, formData, {headers: {'Content-Type': 'multipart/form-data' }})
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success('Fichier PDF importé avec succès');
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    deleteProvidersFile(id,generatedName){
        return axios.post("/api/suppliers/deleteProvidersFile/"+id+"/"+generatedName)
        .then(response => { 
            if (response && response.data) {
                Vue.prototype.$snotify.success("Fichier supprimée avec succès");
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

}

